import React, {useEffect, useState} from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";
import {
    ItemListadoServiciosEntrenamiento,
    listarServiciosEntrenamiento
} from "../../../services/entrenamientoServicios";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicios"
    },
    {
        path: "/servicios/entrenamiento",
        label: "Entrenamiento",
        isActive: true
    }
]

function ListaServiciosEntrenamiento(){
    const [items, setItems] = useState([] as ItemListadoServiciosEntrenamiento[]);

    useEffect(() => {
        async function poblarItems() {
            const resp = await listarServiciosEntrenamiento();
            if(resp){
                setItems(resp);
            }
        }

        poblarItems()
    }, []);

    return (
        <Page description="Visualiza, edita y crea servicios de entrenamiento." title="Mascotas" breadCrumbs={breadCrumbs}>
            <TableSection items={items} />
        </Page>
    );
}

export default ListaServiciosEntrenamiento;